import * as React from 'react';

import { cn } from '@shared/lib';

export interface SettingRowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** trailing control — 보통 <Switch />, 향후 다른 control(button 등)도 허용 */
  children: React.ReactNode;
  disabled?: boolean;
}

// TRAD-1962 — MyPage.tsx 메뉴 행(`flex items-center justify-between px-4 py-3.5`) 규격을
// 그대로 따르는 title/description/trailing-control 행. 알림 설정 센터의 첫 소비처가 아직 없으므로
// (스펙 §3) 소비처에서 trailing control(Switch)에 접근성 라벨(aria-label 또는 aria-labelledby)을
// 직접 연결해야 한다 — 이 컴포넌트는 시각적 레이아웃만 제공.
const SettingRow = React.forwardRef<HTMLDivElement, SettingRowProps>(
  ({ className, title, description, disabled, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center justify-between gap-4 px-4 py-3.5', className)}
      aria-disabled={disabled || undefined}
      {...props}
    >
      {/* 🔴 2026-09-01 정정 — 이 주석은 원래 "App.css의 `#root { text-align: center }`가 상속되므로
          명시 재정의"였다. 그 전역 룰은 TRAD-2101에서 제거됐으므로(가드: src/__tests__/global-css-alignment.test.ts)
          **더 이상 상속되지 않는다**. 아래는 당시 "제거가 리팩터링이 아니라 동작 변경이라 잔재 정리
          티켓에서 일괄 판정한다"며 좌측정렬 클래스를 남겨둔 자리였다.
          🔴 2026-09-11 갱신(TRAD-2099) — 그 "잔재 정리 티켓"이 이거다. dev.xtrading.kr 실측
          (inkX 픽셀 이동 0 — 화면 변화 없음 확인, 가드: text-left-ratchet.test.ts)으로 제거했다.
          이 주석은 여전히 유효하다 — **이 자리를 보고 다른 화면에 우회용 좌측정렬 클래스를 새로
          붙이지 말 것**. #root 전역 중앙정렬이 사라진 지금은 원칙적으로 불필요하다. */}
      <div className="min-w-0 flex-1">
        <p className={cn('text-sm font-medium text-foreground', disabled && 'text-muted-foreground')}>{title}</p>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  ),
);
SettingRow.displayName = 'SettingRow';

export { SettingRow };
